<app-color-list-preview [colorList]="coloredYarnSet" *ngIf="coloredYarnSet" [maximumCreelPositionsToShow]="8" [showDetailsOnClick]="canShowDetailColor"> </app-color-list-preview>
